
import React, { useState, useEffect } from 'react';

import { loginRequest, protectedResources } from "../../authConfig";
//import { useGetSkillData, useUpdateSkillData } from '../../hooks/useSkillData';
import { ISkill } from '../../model/Skill.model';
import { IsCookieFunction } from 'react-router-dom';
import useFetchWithMsal from '../../hooks/useFetchWithMsal';
import { ISkillGroup } from '../../model/SkillGroup.model';

const AddSkillGroupFormComponent: React.FC<{
  skillPathId: number;
  maxIndex: number;
  newGroupCreated(event: ISkillGroup): void;
}> = (props: {
  skillPathId: number;
  maxIndex: number;
  newGroupCreated(event: ISkillGroup): void;
}) => {
    const [editingAtts, seteditingAtts] = useState(false);
    const { error, execute } = useFetchWithMsal({
      scopes: protectedResources.apiCFSkillPath.scopes.read,
    });
    const [loading, setLoading] = useState(true);
    const [callErr, setErr] = useState(null);

    const HandleSubmit = (event: any) => {
      event.preventDefault();
      const formData = new FormData(event.target);
      const inputSGN: string = formData.get("skillGroupName") + "";
      const now = (new Date()).toISOString();
      var sg: any = {
        //skillGroupId: -1,
        skillPathId: props.skillPathId,
        indexNumber: props.maxIndex + 1,
        skillGroupName: inputSGN,
        createdDate: now,
        CreatedBy: "me",
        lastModifiedDate: now,
        lastModifiedBy: "me",
        skills: undefined
      }

      execute("POST", `/api/SkillGroup/addSkillGroup`, sg)
        .then((response: any) => {
          //console.log('api call success');
          props.newGroupCreated(response);
          setLoading(false);
        }).catch((err: any) => {
          setErr(err);
          setLoading(false);
        })
    }
    const HandleToggleEdittingAtts = () => {
      seteditingAtts(!editingAtts);
    }
    if (!editingAtts) {
      <div>
        <button onClick={HandleToggleEdittingAtts}>Add New Skill Group</button>
      </div>;
    }
    return(
    <>
      <div className='aln-center m-t-2'>
        <form onSubmit={HandleSubmit}>
          <p><input type='text' name='skillGroupName' /></p>
          <button className='btn-secondary' type='submit'>Submit New Skill Group</button>
        </form>
      </div>
    </>
  )}
export default AddSkillGroupFormComponent;

